
export const CLOSE_REASONS = [
  "Verified Mbr is patient",
  "Left VM",
  "No Answer",
  "PVD",
  "MVD",
  "Gatekeeper",
  "Hold Time Limit",
  "Prescriber Do Not Contact",
  "Spoke to person",
  "Wrong Phone Number",
  "Prescriber Not at Practice",
  "Member Not at Practice",
];

export const CLOSE_REASONS_FOR_SELECT = CLOSE_REASONS.map(reason => ({ key: reason, value: reason }));
